<template>
<div ref="pbrTopicIndustryDistChart" class="pbr-topic-chart-container" style="height: 190px;">
  {{ $t('charts.special.industryDistribution') }}
</div>
</template>

<script>
import * as echarts from 'echarts'
import {chartColors} from '../analysis/constant'
export default {
  name: "pbrTopicIndustryDistChart",
  props: {
    data: {
      type: Array,
      require: true,
      default: () => []
    }
  },
  data () {
    return {
      chartData: []
    }
  },
  computed: {
    isDark () {
      return this.$store.state.brpaModule.theme === 'dark'
    }
  },
  methods: {
    drawChart (theme = 'light') {
      let self = this
      if (this.pbrTopicIndustryDistChart) {
        this.pbrTopicIndustryDistChart.dispose()
      }
      // {renderer: 'svg',}
      if (this.$refs.pbrTopicIndustryDistChart) {
        this.pbrTopicIndustryDistChart = echarts.init(this.$refs.pbrTopicIndustryDistChart, theme, {devicePixelRatio: 2.5})
        // this.pbrTopicIndustryDistChart.resize({height: 200})
        this.pbrTopicIndustryDistChart.resize({width: 200})
        this.pbrTopicIndustryDistChart.setOption(this.optionPbrTopicIndustryDist)
        this.pbrTopicIndustryDistChart.on('click', function (param) {

        })
      }
    },
    generateOptions () {
      let self = this
      this.optionPbrTopicIndustryDist = {
        color:chartColors,
        title: {
          show: false,
          text: self.$t('charts.special.industryDistribution.name'),
          left: '52%',
          bottom: 20
        },
        tooltip: {
          trigger: 'item',
          formatter: function (a) {
            console.log(a)
            // return params.name + " - " + params.percent + '%'
            let listItem = `${a.seriesName}<br /><i style="display: inline-block;width: 10px;height: 10px;background: ${a.color};margin-right: 5px;border-radius: 50%;}"></i>
                            ${a.value.industry} ：${a.value.percent}</p>`

            return '<div class="showBox">' + listItem + '</div>'
          }
        },
        legend: {
          type:'scroll',
          orient: 'horizontal',
          bottom: 10,
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            fontSize: 10,
            lineHeight: 10,
            color: self.isDark ? '#fff' : '#101010'
          },
          tooltip: {
            show: true,
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
          },
          formatter: function (name) {
            if (!name) return ''
            // 超出几个字符隐藏，鼠标悬浮时显示
            if (name.length > 5) {
              name = name.slice(0, 5) + '...'
            }
            return name
          }
        },
        dataset: {
          // dimensions: ['id','industry', 'percent'],
          // source: this.chartData
          dimensions: ['industry','num', 'percent','industryId',],
          source:this.chartData
        },

        series: [
          {
            name: self.$t('charts.special.industryDistribution.name'),
            type: 'pie',
            radius: '66%',
            // center: [this.showTitle ? '50%' : '35%', '50%', '50%'],
            center: ['30%', '50%', '50%'],
            avoidLabelOverlap: false,
            label: {
              //   show: false,
              normal: {
                formatter: '{@percent}',
                position: 'inside',
                fontSize: 8,
                color: '#fff',
                align: 'center',
                verticalAlign: 'middle'
              }
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '8',
                fontWeight: 'bold'
              }
            },
            labelLine: {
              show: false
            },
            grid: {
              top: this.showTitle ? 40 : 0,
              containLabel: true
            }
          }
        ]
      }
    }
  },
  mounted () {
    const pbrTopicIndustryDistChartData = this.data
    if (pbrTopicIndustryDistChartData && pbrTopicIndustryDistChartData.length > 0 && pbrTopicIndustryDistChartData[0].hasOwnProperty('percent')) {
      pbrTopicIndustryDistChartData.forEach(p => p.num = parseFloat(p.percent))
      this.chartData = pbrTopicIndustryDistChartData
    } else {
      this.chartData = [{id: '', industry: '',num:0, percent: 0}]
    }
    if (this.pbrTopicIndustryDistChart) {
      this.pbrTopicIndustryDistChart.dispose()
    }

    this.generateOptions()
    this.drawChart(this.theme)
  },
  watch: {
    data: {
      handler (newValue, oldValue) {
        const pbrTopicIndustryDistChartData = newValue
        if (pbrTopicIndustryDistChartData && pbrTopicIndustryDistChartData.length > 0 && pbrTopicIndustryDistChartData[0].hasOwnProperty('percent')) {
          pbrTopicIndustryDistChartData.forEach(p => p.num = parseFloat(p.percent))
          this.chartData = pbrTopicIndustryDistChartData
        } else {
          this.chartData = [{industryId: '', industry: '', num: 0, percent: 0}]
        }
        if (this.pbrTopicIndustryDistChart) {
          this.pbrTopicIndustryDistChart.dispose()
        }
        this.generateOptions()
        this.drawChart(this.theme)
      },
      immediate: true
    },
    isDark (n, o) {
      this.generateOptions()
      this.drawChart(this.theme)
    }
  }
}
</script>

<style scoped>

</style>
